export const environment = {
  production: true,
  url: 'https://qa-panel.inercitec.com',
  apiUrl: 'https://qa-api.inercitec.com/api/v1',
  apiNoPrefix: 'https://qa-api.inercitec.com',
  apiGoogleMapsKey: 'AIzaSyBl4c1rtv1VXG5WcD5v_bWQdFirv27EFpk'
};
